import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/subjects/components/SubjectsContent.tsx");
